// extracted by mini-css-extract-plugin
export var emptyState = "_55-d";
export var statCard = "_55-c";
export var table = "_55-0";
export var tableCell = "_55-4";
export var tableCellClickable = "_55-5 _55-4";
export var tableCellDefault = "_55-6 _55-4";
export var tableCellEmpty = "_55-8";
export var tableCellWithValue = "_55-7";
export var tableContainer = "_55-e";
export var tableHeaderWeight = "_55-1";
export var tableHeaderZone = "_55-2";
export var tableRowHeader = "_55-3";
export var viewModeButton = "_55-9";
export var viewModeButtonActive = "_55-a _55-9";
export var viewModeButtonInactive = "_55-b _55-9";